import React from 'react';
import { Helmet } from "react-helmet-async";
import { useI18n } from "../../i8n/useI18n";
import BlogHeroSection from "../sections/blog/hero/BlogHeroSection";
import BlogArticleGridSection from "../sections/blog/articleGrid/BlogArticleGridSection";

const BlogPage = () => {
    const { t } = useI18n();

    return (
        <>
            <Helmet>
                <title>{t("blogPage.hero.title")} | {t("brand.name")}</title>
                <meta name="description" content={t("blogPage.hero.description")} />
            </Helmet>
            <BlogHeroSection />
            <BlogArticleGridSection />
        </>
    );
};

export default BlogPage;
